import { useEffect } from "react"
import { canListActiveJobs, getUser, hasRole, useEnvironment } from "./core/Global";
import { UserTypes } from "./core/Enums";
import { useNavigate } from "react-router-dom";
import { jobsBoardLink } from "./modules/crm/jobs/utils/jobsBoardState";



export default function DefaultRouteView() {

    const env = useEnvironment()
    const user = getUser()
    const navigate = useNavigate()

    const landingPage = () => {
        if (env.brand == "rinvox") return canListActiveJobs() ? jobsBoardLink() : undefined;
        else if (env.brand == "voice" && hasRole("LiveCalls")) return "/dashboard";
        else if (user?.userType == UserTypes.Agent) return "/agents/view/" + user.id
        return undefined;
    }

    useEffect(() => {
        navigate(landingPage() ?? "/agents/view/" + user?.id, {
            replace: true
        })
    }, [])

    return (<></>)
}